"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _uiKit = require("@dbi-tools/ui-kit");

var _helpers = require("../../helpers");

var _heroSlide = require("../../hero-slide.styled");

var _buttons = _interopRequireDefault(require("../buttons"));

var _textImage = _interopRequireDefault(require("../text-image"));

var _heroSlideC = require("./hero-slide-c.styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeroSlideC = function HeroSlideC(_ref) {
  var line1 = _ref.lineOneText,
      line2 = _ref.lineTwoText,
      line3 = _ref.lineThreeText,
      line4 = _ref.lineFourText,
      type = _ref.textType,
      images = _ref.textAsImages,
      buttons = _ref.buttons,
      position = _ref.contentPosition,
      bg = _ref.textBackgroundColor,
      bgStyles = _ref.bgStyles;
  var offset = (0, _helpers.setPosition)({
    position: position,
    offset: {
      left: 0,
      center: 1,
      right: 2
    }
  });
  var isBgColorBlock = bg !== 'transparent';
  return /*#__PURE__*/_react.default.createElement(_heroSlideC.Wrap, {
    bgStyles: isBgColorBlock ? bgStyles : ''
  }, /*#__PURE__*/_react.default.createElement(_heroSlideC.ContainerStyled, null, /*#__PURE__*/_react.default.createElement(_uiKit.Row, null, /*#__PURE__*/_react.default.createElement(_uiKit.Col, {
    lg: 10,
    md: 12,
    lgOffset: offset,
    noGutter: true
  }, /*#__PURE__*/_react.default.createElement(_heroSlideC.HeroSlideBlock, {
    bg: bg
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Row, null, /*#__PURE__*/_react.default.createElement(_uiKit.Col, {
    lg: 7,
    md: 6,
    alignSelf: "center"
  }, /*#__PURE__*/_react.default.createElement(_heroSlideC.Content, null, type === 'type_text' ? /*#__PURE__*/_react.default.createElement(_uiKit.Row, null, /*#__PURE__*/_react.default.createElement(_uiKit.Col, {
    lg: 6.5,
    md: 12,
    alignSelf: "center"
  }, line1 && /*#__PURE__*/_react.default.createElement(_heroSlide.Line1, {
    as: "h4"
  }, line1), line2 && /*#__PURE__*/_react.default.createElement(_heroSlide.Line2, {
    as: "h2"
  }, line2), line3 && /*#__PURE__*/_react.default.createElement(_heroSlide.Line3, {
    as: "h2"
  }, line3)), /*#__PURE__*/_react.default.createElement(_uiKit.Col, {
    lg: 5.5,
    md: 12,
    alignSelf: "center"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Box, {
    mt: {
      xs: 20,
      lg: 0
    }
  }, line4 && /*#__PURE__*/_react.default.createElement(_heroSlide.Line4, {
    as: "h4"
  }, line4)))) : /*#__PURE__*/_react.default.createElement(_textImage.default, {
    images: images
  }))), /*#__PURE__*/_react.default.createElement(_uiKit.Col, {
    lg: 5,
    md: 6,
    alignSelf: "center"
  }, /*#__PURE__*/_react.default.createElement(_heroSlideC.ButtonsWrap, null, /*#__PURE__*/_react.default.createElement(_buttons.default, {
    color: bg,
    buttons: buttons
  })))))))));
};

var _default = HeroSlideC;
exports.default = _default;